import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetScrollPosition } from '../utils/scrollUtils';

/**
 * Component that scrolls to top when location changes
 * Can be placed anywhere in the component tree
 */
const ScrollToTop = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        resetScrollPosition();
    }, [location.pathname]);

    return children || null;
};

export default ScrollToTop;